var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container" }, [
    _vm.imageSrc
      ? _c("div", { staticClass: "illustration-wrapper" }, [
          _vm.imageSrc
            ? _c("img", {
                staticClass: "illustration",
                attrs: { src: _vm.imageSrc, alt: "illustration" },
              })
            : _vm._e(),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "text-wrapper" }, [
      _vm.title
        ? _c("h1", [_vm._v("\n      " + _vm._s(_vm.title) + "\n    ")])
        : _vm._e(),
      _vm._v(" "),
      _vm.subtitle
        ? _c("p", [_vm._v("\n      " + _vm._s(_vm.subtitle) + "\n    ")])
        : _vm._e(),
    ]),
    _vm._v(" "),
    _vm.confirmActionText
      ? _c(
          "button",
          {
            staticClass: "white--text mr-2 v-btn theme--light primary",
            on: { click: _vm.confirmAction },
          },
          [_vm._v("\n    " + _vm._s(_vm.confirmActionText) + "\n  ")]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }